import * as actions from 'redux/actions/filters.actions'

const initialState = {
  device: ''
}

const filtersReducer = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case actions.setFilters.type:
      return {
        ...state,
        ...payload.filters
      }
    case 'ROUTE_CHANGE':
    case actions.resetFilters.type:
      return {
        ...initialState
      }
    default:
      return state
  }
}

export default filtersReducer
